module.exports = __webpack_public_path__ + "img/empty-project.41605c30.png";